import { createFileRoute } from '@tanstack/react-router';
import { validateTableSearch } from '@utils/tabHelpers';
import RoleListPage from '@features/roles/RoleListPage';

export const Route = createFileRoute('/w/roles/')({
  validateSearch: (search: Record<string, unknown>) =>
    validateTableSearch(search, { sortBy: 'createdAt', sortDir: 'desc', tab: 'ALL' }),
  component: WorkpayRolesPage,
});

function WorkpayRolesPage() {
  const searchParams = Route.useSearch();
  return <RoleListPage routeTo="/w/roles" addRoute="/w/roles/add" searchParams={searchParams} />;
}
